export const TICKET_ADD_REQUEST = "TICKET_ADD_REQUEST";
export const TICKET_ADD_SUCCESS = "TICKET_ADD_SUCCESS";
export const TICKET_ADD_FAIL = "TICKET_ADD_FAIL";

export const TICKET_DETAIL_REQUEST = "TICKET_DETAIL_REQUEST";
export const TICKET_DETAIL_SUCCESS = "TICKET_DETAIL_SUCCESS";
export const TICKET_DETAIL_FAIL = "TICKET_DETAIL_FAIL";

export const TICKET_UPDATE_REQUEST = "TICKET_UPDATE_REQUEST";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";
export const TICKET_UPDATE_FAIL = "TICKET_UPDATE_FAIL";

export const TICKET_DELETE_REQUEST = "TICKET_DELETE_REQUEST";
export const TICKET_DELETE_SUCCESS = "TICKET_DELETE_SUCCESS";
export const TICKET_DELETE_FAIL = "TICKET_DELETE_FAIL";

export const TICKET_LIST_REQUEST = "TICKET_LIST_REQUEST";
export const TICKET_LIST_SUCCESS = "TICKET_LIST_SUCCESS";
export const TICKET_LIST_FAIL = "TICKET_LIST_FAIL";
